import React from 'react'

import "styles/components/popup.sass"
import "pages/Styles/UIKit.sass"

import Popup from "../../../components/Popup";
import notifyUser from "../../../methods/notifyUser";
import {connect} from "react-redux";
import ApiKeyField from "../../../components/ApiKeyField";

const ARTICLE_URL = 'https://rentprog.ru/ru/articles/9?utm_source=okidoki&utm_media=tg&utm_post=integration&ref=okidoki'
const GUIDE_URL = 'https://rentprog.ru/ru/categories/12/guides/50?utm_source=okidoki&utm_media=tg&utm_post=integration&ref=okidoki'

type Props = {
    close: Function,
    $store: any,
    $commitToStore: Function,
}

let RentProgIntegrationPopup: any = function RentProgIntegrationPopup(props: Props) {
    function onCopy() {
        notifyUser(props, "API ключ скопирован. Теперь вставьте его в настройках интеграции в RentProg");
    }

    function apiKey() {
        return `${props.$store.userSession.realty_api_key}`
    }

    return <Popup
        maxWidth="650px"
        onClose={() => {
            props.close()
        }}
    >
        <div>
            <div className="commonTitle" style={{marginBottom: 16}}>
                Интеграция с RentProg
            </div>
            <div className="commonSubtitle" style={{marginBottom: 24, lineHeight: '1.6'}}>
                RentProg — одна из лучших CRM-систем для прокатного бизнеса. Теперь вы можете мгновенно отправлять электронные версии документов своим клиентам прямо из аккаунта RentProg, а подписание осуществляется удаленно, без бумажной волокиты.
            </div>

            <div className="commonLabel" style={{marginBottom: 12}}>
                Преимущества RentProg:
            </div>
            <ul style={{marginBottom: 24, paddingLeft: 20, lineHeight: '1.8'}}>
                <li>Разработана специалистами с многолетним опытом работы в сфере проката</li>
                <li>Обеспечивает полный цикл автоматизации: от бронирования до финансового учета</li>
                <li>До 70% сокращает время руководителей благодаря оптимизации управленческих задач</li>
                <li>Поддерживает масштабируемые тарифы для разных объемов бизнеса</li>
            </ul>

            <hr className="newHR"/>

            <div className="commonLabel" style={{marginBottom: 16}}>
                Инструкция по подключению
            </div>
            <div className="commonSubtitle" style={{marginBottom: 16, lineHeight: '1.6'}}>
                Для настройки интеграции выполните следующие шаги:
            </div>
            <ol style={{marginBottom: 24, paddingLeft: 20, lineHeight: '1.8'}}>
                <li style={{marginBottom: 8}}>
                    Перейдите в раздел интеграций в RentProg: <strong>Меню → Компания → Настройки компании → Интеграции</strong>
                </li>
                <li style={{marginBottom: 8}}>
                    Найдите в списке «OkiDoki сервис электронного подписания договоров» и нажмите кнопку «Зарегистрироваться в OkiDoki и получить API ключ»
                </li>
                <li style={{marginBottom: 8}}>
                    Скопируйте ваш API-ключ из личного кабинета OkiDoki (поле ниже)
                </li>
                <li style={{marginBottom: 8}}>
                    Вставьте скопированный ключ в поле «API ключ» в настройках интеграции RentProg
                </li>
                <li>
                    Сохраните изменения
                </li>
            </ol>

            <hr className="newHR"/>

            <div className="Body_15" style={{textAlign: "left", marginBottom: 16}}>
                Скопируйте ваш API ключ и вставьте его в настройках интеграции в RentProg:
            </div>
            <div>
                <ApiKeyField
                    title="API ключ"
                    value={apiKey()}
                    onCopy={onCopy}
                />
            </div>

            <hr className="newHR"/>

            <div className="commonLabel" style={{marginBottom: 16}}>
                Полезные ссылки
            </div>
            <div style={{display: 'flex', gap: '12px', marginBottom: 24, flexWrap: 'wrap'}}>
                <a
                    href={ARTICLE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="new withTitle _wa"
                    style={{display: 'inline-block', flex: '1', minWidth: '200px'}}
                >
                    Статья об интеграции
                </a>
                <a
                    href={GUIDE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="new withTitle secondary _wa"
                    style={{display: 'inline-block', flex: '1', minWidth: '200px'}}
                >
                    Инструкция по подключению
                </a>
            </div>

            <hr className="newHR"/>

            <div className="commonLabel" style={{marginBottom: 16}}>
                Нужна помощь с интеграцией?
            </div>
            <div className="commonSubtitle" style={{marginBottom: 16}}>
                Обратитесь к нашей технической поддержке:
            </div>
            
            <div style={{marginBottom: 24}}>
                <div className="commonSubtitle" style={{marginBottom: 8}}>
                    <strong>Telegram:</strong> <a href="https://t.me/superpupermegaman" target="_blank" rel="noopener noreferrer" style={{color: '#1FA3EE', textDecoration: 'none'}}>@superpupermegaman</a>
                </div>
                <div className="commonSubtitle" style={{marginBottom: 16}}>
                    <strong>Телефон:</strong> <a href="tel:+79397163709" style={{color: '#1FA3EE', textDecoration: 'none'}}>+7 (939) 716-37-09</a>
                </div>
            </div>

            <button
                className="new withTitle _wa"
                onClick={() => {
                    props.close()
                }}
            >
                <div className="buttonsContainer">
                    <span>Закрыть</span>
                </div>
            </button>
        </div>
    </Popup>
}

RentProgIntegrationPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(RentProgIntegrationPopup)

export default RentProgIntegrationPopup

